import script from "./MultipleFileUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultipleFileUploader.vue?vue&type=script&setup=true&lang=ts"

import "./MultipleFileUploader.vue?vue&type=style&index=0&id=0f218382&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f218382"]])

export default __exports__